import { Constants } from 'core';
import { useShowCause } from 'core/Api';
import { BASE_URL } from 'core/Utils';

import { useShowCurrentCampaign } from '../../../../api';

const useCampaignShortLinks = () => {
  const { data: campaign } = useShowCurrentCampaign();
  const { data: cause } = useShowCause(campaign?.cause_id);
  const causeShortener = cause?.shortener || cause?.uuid || '';
  const campaignShortener = campaign?.shortener || campaign?.uuid || '';

  const campaignPageLinkBaseUrl = `${BASE_URL}${Constants.appRoutes.campaign(
    causeShortener,
    campaignShortener
  )}`;

  const eventPageLinkBaseUrl = `${BASE_URL}${Constants.appRoutes.event(
    causeShortener,
    campaignShortener
  )}`;

  const participantCenterUrl = `${BASE_URL}${Constants.appRoutes.participantCenter(
    causeShortener,
    campaignShortener
  )}`;
  const registrationUrl = `${BASE_URL}${Constants.appRoutes.campaignRegistration(
    causeShortener,
    campaignShortener
  )}`;
  const rallyUpUrlLink = campaign?.integration?.url;
  return {
    campaignPageLinkBaseUrl,
    eventPageLinkBaseUrl,
    participantCenterUrl,
    registrationUrl,
    campaignShortener,
    causeShortener,
    rallyUpUrlLink,
  };
};

export { useCampaignShortLinks };
